import { Component, Input } from '@angular/core';
import { PostModel } from '@data/models/post.model';
import { Router } from '@angular/router';
import { SkeletonTypeEnum } from '@components/skeleton/skeleton.enum';
import urlHelper from '../../../common/urlHelper';

@Component({
	selector: 'app-card-book',
	templateUrl: './card-book.component.html',
	styleUrls: ['./card-book.component.scss']
})
export class CardBookComponent {
	skeletonOptions = SkeletonTypeEnum;

	@Input() generateLink = true;
	@Input() post: PostModel = new PostModel();
	@Input() showIcon = true;
	@Input() showAuthor = true;
	@Input() showTitle = true;
	@Input() showPrice = false;
	@Input() showMonetized = false;
	@Input() showViewer = false;
	@Input() isShop = false;
	@Input() ranking = 0;

	constructor(private router: Router) {
		console.log(this.showMonetized, 'halo');
	}

	onDetailKarya(): void {
		const postId = this.post.id ?? this.post._id;
		const postUrl = urlHelper.generatePostUrl(postId, this.post.title);
		this.router.navigate([postUrl]);
	}

	onDetailShop(): void {
		this.router.navigate(['/shop/book/1']);
	}
}
